export default [
  {
    path: '/rental/report/MY_006/home_rental_charges',
    name: 'MY_006_DailyHomeRentalCharges',
    component: () =>
      import(
        /* webpackChunkName: "rental_MY_006_report" */ './DailyHomeRentalCharges.vue'
      )
  },
  {
    path: '/rental/report/MY_006/income_develop',
    name: 'MY_006_DailyIncomeOfDevelopAndSecuity',
    component: () =>
      import(
        /* webpackChunkName: "rental_MY_006_report" */ './DailyIncomeOfDevelop.vue'
      )
  },
  {
    path: '/report/report/MY_006/rental_charges',
    name: 'MY_006_MothlyRentalCharges',
    component: () =>
      import(
        /* webpackChunkName: "rental_MY_006_report" */ './MothlyRentalCharges.vue'
      )
  },
  {
    path: '/report/report/MY_006/income_others',
    name: 'MY_006_MothlyIncomeOfOthers',
    component: () =>
      import(
        /* webpackChunkName: "rental_MY_006_report" */ './MothlyIncomeOfOthers.vue'
      )
  },
  {
    path: '/report/report/MY_006/balance_due_home_rental',
    name: 'MY_006_MothlyBalanceDueListForHomeRental',
    component: () =>
      import(
        /* webpackChunkName: "rental_MY_006_report" */ './MothlyBalanceDueListForHomeRental.vue'
      )
  }
]
